import { getDeviceTimezone } from '@/utils/date';
import { transformToManagerProspectRowData } from '@/experiences/sales-portal/domain/prospects/screens/prospects/blocs/transformers/manager-prospects-transformers';
import { useGeneratedSalesPortalManagerProspectsQuery } from '@/experiences/sales-portal/domain/prospects/screens/prospects/blocs/documents/sales-portal-manager-prospects.generated';
import { useMemo } from 'react';
import type { ApolloError } from '@apollo/client';
import type { ManagerProspectRowData } from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';

interface UseManagerProspectsLoaderParams {
  businessOrganizationUUID: string;
}

interface UseManagerProspectsLoaderResult {
  prospects: ManagerProspectRowData[];
  prospectsError?: ApolloError;
  prospectsLoading: boolean;
  refetch: () => void;
}

export function useManagerProspectsLoader({
  businessOrganizationUUID,
}: UseManagerProspectsLoaderParams): UseManagerProspectsLoaderResult {
  const userTimezone = getDeviceTimezone();

  const {
    data: prospectData,
    error: prospectsError,
    loading: prospectsLoading,
    refetch,
  } = useGeneratedSalesPortalManagerProspectsQuery({
    notifyOnNetworkStatusChange: true,
    variables: {
      businessOrganizationUUID,
      employeeIds: [],
      stages: [],
      userTimezone,
    },
  });

  const queryRows = useMemo(
    () => prospectData?.getSalesPortalManagerProspectList ?? [],
    [prospectData],
  );

  const prospects = useMemo(
    () => transformToManagerProspectRowData(queryRows),
    [queryRows],
  );

  return { prospects, prospectsError, prospectsLoading, refetch };
}
